const BASE = "/files";

const UPLOAD_MULTIPLE_FILES = `${BASE}/upload-files`;

export const FILE_ROUTE = {
  BASE,
  UPLOAD_MULTIPLE_FILES,
};
